import React from 'react';
import {useComponent} from '../component-library';
import {FormField} from '../utils/use-form-field';
import {SelectOption, SelectOptionGroup} from '../types';
import {UserDrivingProfile} from '@volkswagen-onehub/whitelabel-e-mobility-data-types';

interface SelectConsolidatedProps {
  label?: string;
  formFieldA: FormField<any>;
  formFieldB: FormField<any>;
  combinedSelectOptions: SelectOption[] | SelectOptionGroup[];
  testId: string;
  setSelectedUserDrivingProfile?: (
    selectedUserDrivingProfile: UserDrivingProfile | undefined
  ) => void;
}

export function SelectConsolidated({
  label,
  formFieldA,
  formFieldB,
  combinedSelectOptions,
  testId,
  setSelectedUserDrivingProfile,
}: SelectConsolidatedProps): JSX.Element {
  const Select = useComponent('Select');
  const GroupedSelect = useComponent('GroupedSelect');

  const onChangeConsolidated = (value: string): void => {
    const valueElements = value.split(',');
    const formFieldValueA = valueElements[0];
    const formFieldValueB = valueElements[1];
    if (setSelectedUserDrivingProfile) {
      setSelectedUserDrivingProfile(undefined);
    }
    formFieldA.onChange(formFieldValueA);
    formFieldB.onChange(formFieldValueB);
  };

  return (combinedSelectOptions as SelectOptionGroup[])[0].options ? (
    <GroupedSelect
      label={label}
      selectedValue={`${formFieldA.value},${formFieldB.value}`}
      onChange={onChangeConsolidated as (id: string) => void}
      optionGroups={combinedSelectOptions as SelectOptionGroup[]}
      testid={testId}
    />
  ) : (
    <Select
      label={label}
      selectedValue={`${formFieldA.value},${formFieldB.value}`}
      onChange={onChangeConsolidated as (id: string) => void}
      options={combinedSelectOptions as SelectOption[]}
      testid={testId}
    />
  );
}
